import clsx from "clsx";
import PropTypes from "prop-types";
import { STATUS, isInFlight } from "../../domain/mediaUpload";
import { Progress, Typography } from "../../themeV2";
import stageLabel from "../../util/mediaStageLabels";
import s from "./MediaProgress.module.css";

const UPLOAD_LABEL = "Uploading...";

// Which of the two numbers an upload state is actually reporting. Callers used
// to decide this themselves, and then had to keep two bars in sync.
export const reading = ({ status, uploadPercent, processPercent, stage }) =>
  isInFlight(status)
    ? { percent: uploadPercent, label: UPLOAD_LABEL, name: "Upload progress" }
    : {
        percent: processPercent,
        label: stageLabel(stage),
        name: "Processing progress",
      };

function MediaProgress({ state, className }) {
  const { percent, label, name } = reading(state);

  return (
    <div className={clsx(s.root, className)}>
      <Progress value={percent} label={name} />
      <div className={s.labels}>
        {/* Only the stage is announced. The percentage ticks several times a
            second during transcoding — it lives on the progressbar's
            aria-valuenow, which screen readers report on request. */}
        <Typography variant="label-sm" color="variant" aria-live="polite">
          {label}
        </Typography>
        {percent != null && (
          <Typography variant="label-sm" color="variant">
            {`${Math.round(percent)}%`}
          </Typography>
        )}
      </div>
    </div>
  );
}

MediaProgress.propTypes = {
  state: PropTypes.shape({
    status: PropTypes.oneOf(Object.values(STATUS)).isRequired,
    uploadPercent: PropTypes.number,
    processPercent: PropTypes.number,
    stage: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
};

export default MediaProgress;
